// Coordonnées affichées sur l'accueil
export const EMAIL = "Alexandre.bonefons@outlook.fr";
export const LINKEDIN_URL = "https://www.linkedin.com/in/alexandre-bonefons-166875250/";
export const GITHUB_URL = "https://github.com/CallMeAl3x";
